import { YANDEX_METRIKA_ID } from "../../const";
import { useEffect, useState } from 'react';

declare global {
  interface Window {
    ym?: (...args: any[]) => void;
  }
}

const YandexMetrika = () => {
  const [isMetrikaLoaded, setIsMetrikaLoaded] = useState(false);
  const isProduction = process.env.NODE_ENV === "production";
  const [isUserAgreedToCookies, setIsUserAgreedToCookies] = useState(
    localStorage.getItem("cookiesAccepted") === "true"
  );

  useEffect(() => {
    const handleScroll = () => {
      // if (!isUserAgreedToCookies || !isProduction || isMetrikaLoaded) return;
      if (!isUserAgreedToCookies || isMetrikaLoaded) return;

      const scriptContent = `
          (function(m,e,t,r,i,k,a){
            m[i]=m[i]||function(){
              (m[i].a=m[i].a||[]).push(arguments);
            };
            m[i].l=1*new Date();
            for (var j = 0; j < document.scripts.length; j++) {
              if (document.scripts[j].src === r) { return; }
            }
            k=e.createElement(t),
            a=e.getElementsByTagName(t)[0],
            k.async=1,
            k.src=r,
            a.parentNode.insertBefore(k,a)
          })
          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
          ym(${YANDEX_METRIKA_ID}, "init", {
            clickmap:false,
            trackLinks:false,
            accurateTrackBounce:false,
            webvisor:true
          });
        `;

        const script = document.createElement('script');
        script.async = true;
        script.innerHTML = scriptContent;
        document.body.appendChild(script);

        setIsMetrikaLoaded(true);
        window.dispatchEvent(new Event("metrika-loaded"));
    };

    window.addEventListener('scroll', handleScroll, { once: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMetrikaLoaded, isUserAgreedToCookies]);

  useEffect(() => {
    const handleCookiesAcceptedChange = () => {
      const cookiesAccepted = localStorage.getItem("cookiesAccepted") === "true";
      setIsUserAgreedToCookies(cookiesAccepted);
    };

    window.addEventListener("cookiesAccepted", handleCookiesAcceptedChange);

    return () => {
      window.removeEventListener("cookiesAccepted", handleCookiesAcceptedChange);
    };
  }, []);

  return null;
};

export default YandexMetrika;
